<style lang="scss" scoped>
.task-container-empty-icon {
  text-align: center;
  color: rgba(0, 0, 0, 0.2);
  font-size: 100px;
  margin: 3rem 0;
  padding: 3rem 0;
}
</style>

<script>
import urls from '@/api/urls'
import { sortByKeys } from '@/lib/utils'
import { filter, concat, find, groupBy } from 'lodash'
import { getTasks, createTask } from '@/api'
import { mapMutations } from 'vuex'

export default {
  props: {
    variant: {
      type: String,
      default: 'default'
    },
    view: {
      type: String,
      default: null
    },
    autoload: {
      type: Boolean,
      default: false
    },
    hideNewTaskButton: {
      type: Boolean,
      default: false
    },
    pageSize: {
      type: Number,
      default: 200
    },
    userId: {
      type: [Number, String],
      default: null
    },
    query: {
      type: String,
      default: null
    },
    groupByDay: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      page: 1,
      loaded: false,
      tasks: [],
      days: [],
      hasMoreTasks: false,
      upcomingTaskCount: 0,
      urls
    }
  },
  computed: {
    hasTasks() {
      return filter(this.tasks, task => !task._deleted).length > 0
    },
    newTasksDueAt() {
      return null
    }
  },
  watch: {
    tasks: {
      handler() {
        this.days = sortByKeys(
          groupBy(
            this.tasks,
            task => moment(task.due_at).utc().format('YYYY-MM-DD')
          )
        )
      },
      deep: true
    },
    '$route' (to, from) {
      this.tasks = []
      this.loaded = false
      this.loadMoreTasks(1)
    }
  },
  mounted () {
    if (this.autoload) {
      this.loadMoreTasks(1)
    }
    $(window).on('createNewTask.requested', () => {
      this.createNewTask()
    })
  },
  methods: {
    ...mapMutations('tasks', [
      'incrementEditingCount',
      'resetEditingCount'
    ]),
    async createNewTask () {
      let response = await createTask({
        due_at: this.newTasksDueAt
      })
      this.tasks.push(response.data.data)
      this.$nextTick(() => {
        const task = find(this.tasks, {'id': response.data.data.id})
        task._editing = true
      })
    },
    async loadMoreTasks (page) {
      if (page) {
        this.page = parseInt(page)
      } else {
        this.page++
      }
      const response = await getTasks(
        this.view,
        this.userId,
        this.page,
        this.pageSize,
        this.query
      )
      if (this.page === 1) {
        this.tasks = []
        this.resetEditingCount()
      }
      this.tasks = concat(this.tasks, response.data.data)
      this.hasMoreTasks = response.data.meta.current_page !== response.data.meta.last_page
      this.upcomingTaskCount = response.data.upcoming
      this.loaded = true
    }
  }
}
</script>